import {
  CREATESTAFFCARDTEMPLATE,
  GETSTAFFCARDTEMPLATE,
  DELETESTAFFCARDTEMPLATE,
  UPDATESTAFFCARDTEMPLATE,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETSTAFFCARDTEMPLATE:
      return {
        ...state,
        staffcardtemplateList: action.payload.data,
      };
    case UPDATESTAFFCARDTEMPLATE:
      return {
        ...state,
        staffcardtemplateUpdateStatus: action.payload.success,
      };

    case DELETESTAFFCARDTEMPLATE:
      return {
        ...state,
        staffcardtemplateDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
